import React from 'react'
import Cdata from '../data/Cdata'
function Travel() {
  return (
    <div className='container pb-5'>
       <div className='row pt-5'>
      {Cdata.slice(0,3).map((a)=>(
        <div className='col-lg-4'>
        <div className='card travels'>
         
          <img className='w-100' src={a.image}/>
          <div className='card-body'>
          <h5 className='fw-normal pt-4 pb-2'>{a.description}</h5>
          <div className='d-flex text-secondary'>
          <i class="bi bi-globe fs-6"></i>
          <p className=' ps-2'>{a.title}</p>
          </div>
            <hr/>
            <div className='d-flex text-secondary'>
          <i class="bi bi-clock-fill fs-6"></i>
          <p className=' ps-2'>3 Day 2 Night</p>
          </div>
          <div className='d-flex pt-3 pb-2'>
          <h5 className='fw-semibold'>${a.price}</h5>
          <button type="button" class="btn ms-auto book px-4 py-2">Book Now</button>
          </div>
          
          </div>
        </div>
       </div>
      
      ))}
      </div>
    </div>
  )
}

export default Travel
